import React from "react";
import { Link } from "react-router-dom";
import { Scale } from "lucide-react";

export default function DisclaimerFooter({ className = "" }) {
  return (
    <footer className={`text-center py-4 px-6 ${className}`} data-testid="legal-disclaimer">
      <p className="text-[11px] leading-relaxed max-w-2xl mx-auto flex items-center justify-center gap-1.5 flex-wrap" style={{ color: "var(--ek-text-muted)" }}>
        <Scale className="h-3 w-3 shrink-0" />
        <span><b style={{ color: "var(--ek-text-secondary)" }}>Not legal advice.</b> EvidenceKeeper is not a law firm and does not provide legal advice. It helps you preserve and organize records.</span>
      </p>
      <p className="text-[10px] mt-1" style={{ color: "var(--ek-text-muted)" }}>
        <Link to="/privacy" className="hover:text-slate-300">Privacy</Link>
        <span className="mx-2">·</span>
        <Link to="/terms" className="hover:text-slate-300">Terms</Link>
      </p>
    </footer>
  );
}
